import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    windheight: '',
    HomeNum:'',
    Ai_token: localStorage.getItem('aojuAi_token') ? localStorage.getItem('aojuAi_token') : '',
    Ai_userName: localStorage.getItem('aojuAi_userName') ? localStorage.getItem('aojuAi_userName') : '',
    Ai_userPhone: localStorage.getItem('aojuAi_userPhone') ? localStorage.getItem('aojuAi_userPhone') : '',
    Ai_userInfo: localStorage.getItem('aojuAi_userInfo') ? JSON.parse(localStorage.getItem('aojuAi_userInfo')) : '',
  },
  mutations: {
    changeuser(state, user) {
      state.Ai_token = user.userMsg.aiUserAes;
      state.Ai_userName = user.userMsg.auName;
      state.Ai_userPhone = user.userMsg.auPhone;
      state.Ai_userInfo = user.userMsg;
      localStorage.setItem('aojuAi_token', user.userMsg.aiUserAes);
      localStorage.setItem('aojuAi_userName', user.userMsg.auName);
      localStorage.setItem('aojuAi_userPhone', user.userMsg.auPhone);
      localStorage.setItem('aojuAi_userInfo', JSON.stringify(user.userMsg));

    },
    getWindowHeight(state, data) {
      state.windheight = data.windheight;
    },
    getHomeNum(state, data) {
      console.log(data);
      state.HomeNum = data.HomeNum;
    }
  },
  actions: {
  },
  modules: {
  }
})
